"use client"

import { useState } from "react"
import "./UIFaq.css"

const faqData = [
  {
    question: "What is UX/UI design?",
    answer:
      "UX stands for User Experience, and it focuses on user goals and the product’s function. In other words, it pretends to understand and map how the user navigates through a website on a cognitive level. UI stands for User Interface and is concerned with the visual and interactive aspects of your web or app solution. It deals with the product’s look and feel, layout, brand guidelines, features, and accessibility. Therefore, UX design is closely related to user research and information architecture, while UI design is related to the graphical layout.",
  },
  {
    question: "Why is UX/UI design important?",
    answer:
      "UX/UI Design allows you to improve your product's user experience by ensuring that the users’ needs and expectations are met in the best possible way. Having a great web or mobile app and providing what users are really looking for is a key factor to increase user confidence and engagement.Even while practically every sector strives to better only its user experience, some industries are spending a significant amount of time, effort, and money on UI/UX design to transform the outlook of traditional services into something more efficient and productive.",
  },
  {
    question: "How can UX/UI designer help  you?",
    answer:
      "Our UX/UI Designers are the most reliable professionals to guide you on our PDP and help you get your product off the ground. They work closely with the product owner to guarantee that the business goals are met and make sure none of the key steps are overridden. Their expertise is followed by understanding the process and the target to ensure your site is user-friendly and functional considering users’ needs and expectations.",
  },
  {
    question:
      "Why is our Product Design Process the most efficient?",
    answer:
      "We developed and perfected our PDP over the years, based on existing techniques and alongside field experience and feedback. It’s focused on providing exceptional user interface and user experience design both on web and mobile apps while keeping costs and benefits balanced on a rapid market launch..",
  },
  {
    question: "How much does it cost to design a product?",
    answer:
      "The cost to design a product typically varies between $33k and $43k, depending on the complexity of your digital product",
  },
  {
    question: "How long does it take to design a product?",
    answer:
      "Our design team typically takes 1,5 to 3 months to design a digital product, depending on your requirements.",
  },
  {
    question:
      "What are the 5 elements of product design?",
    answer:
      "When it comes to product design, the end user and a great user experience must be our main priorities. We serve as the focal point for all the factors that influence its development. For instance, we interact with software, manufacturing, engineering, etc. Therefore, it's crucial for us to comprehend each of these fundamental operations. Hence, a product must: 1. Be authent 2. Provide unique experienc 3. Have an effective desi 4. Do one thing extremely we 5. Solve pain points",
  },
 
 
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section3133">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title">UI/UX DESIGN SERVICES</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
